.tree-icon-right:before {
  font-family: $font-family-icon;
  content: "\f054" !important;
  right: 15px;
  top: 3px;
  font-size: 0.6rem;
  line-height: 2;
  border-style: none;
  font-weight: 900;
}

.aciTree, .aciTree.aciTreeFullRow {
    & .aciTreeButton, & .aciTreePush, & .aciTreeItem, & .aciTreeIcon, & .aciTreeText, & .aciTreeColumn {
        color: $tree-text-fg;
    }

    .aciTreeLi {
      display: grid !important;
      cursor: pointer;
    }

    .aciTreeText {
      font-family: $font-family-primary !important;
      font-size: $tree-font-size !important;
    }

    .aciTreeUl {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .aciTreeLine {
      margin: unset !important;
      border: unset !important;
    }

    .aciTreeSelected > .aciTreeLine {
        background: unset !important;
        background-color: $tree-bg-selected !important;
        border-color: $color-primary-light;
        border-right: $active-border !important;
        border-left: none !important;
        border-top: none !important;
        border-bottom: none !important;
        -webkit-border-radius: none !important;
        -moz-border-radius: none !important;
        border-radius: none !important;

        & .aciTreeItem {
            background-color: $tree-bg-selected;
            border: 1px solid transparent;
            -webkit-border-radius: none !important;
            -moz-border-radius: none !important;
            border-radius: none !important;
            color: $tree-fg-selected;
        }

        & .aciTreeText {
          color: $tree-text-hover-fg;
        }

        & .aciTreePush {
          color: $tree-text-hover-fg;
        }

    }

    .aciTreeItem {
      white-space: nowrap !important;
    }

    &.aciTreeLoad {
      background: none;
    }

    .aciTreeLine.aciTreeHover {
        background: unset !important;
        background-color: $tree-bg-hover !important;
        -webkit-border-radius: none !important;
        -moz-border-radius: none !important;
        border-radius: none !important;
        & .aciTreeItem {
            background-color: inherit;
            border: 1px solid transparent;
            -webkit-border-radius: none !important;
            -moz-border-radius: none !important;
            border-radius: none !important;
            color: $tree-fg-hover;
        }

        & .aciTreeText {
          color: $tree-text-hover-fg;
        }

        & .aciTreePush {
          color: $tree-text-hover-fg;
        }

    }

    &.aciTreeFocus {

        & .aciTreeFocus > .aciTreeLine  {
          background-color: $tree-bg-selected !important;
          border-right: $active-border !important;
        }

        & .aciTreeSelected >.aciTreeLine .aciTreeItem {
          background-color: $tree-bg-selected;
        }

        & .aciTreeFocus >.aciTreeLine .aciTreeItem,
        & .aciTreeSelected.aciTreeFocus >.aciTreeLine .aciTreeItem {
          border: 1px solid transparent;
          color: $tree-fg-selected;
        }
    }

    .aciTreeButton {
      background: none;
    }

    .aciTreePush {
      background: none;
      text-align: center;
      vertical-align: middle;
      font-size: 0.85em;
    }

    .aciTreeEntry, .aciTreeBranch, &[dir=rtl] .aciTreeBranch {
        overflow:hidden;
        background: none !important;
    }

    .aciTreeInode>.aciTreeLine .aciTreePush {
        &:before,
        &.aciTreeHover:before {
          background-position: 6px center !important;
          font-family: $font-family-icon;
          content: "\f054" !important;
          border-style: none;
          margin-left: 5px;
          font-weight: 900;
        }
    }

    .aciTreeLoad>.aciTreeLine .aciTreePush {
        &:before,
        &.aciTreeHover:before {
          content: " " !important;
          font-weight: 900;
        }
    }

    .aciTreeOpen >.aciTreeLine .aciTreePush {
        &:before,
        &.aciTreeHover:before {
          background-position: -14px center !important;
          font-family: $font-family-icon;
          content: "\f078" !important;
          border-style: none;
          margin-left: 5px;
          font-weight: 900;
        }
    }

    .aciTreePush>span {
        width: 15px;
        height: 15px;
        left: 2px;
        background: $loader-icon-small 0 0 no-repeat;
        background-color: inherit!important;
    }
}
